import {
  CategoryFilter,
  CategoryFilterOption
} from "./routes/productListing/types";

export const getDeepSelectedCategory = (filter: CategoryFilter) => {
  const getDeepestSelectedOptions = (
    level: CategoryFilterOption
  ): CategoryFilterOption[] => {
    if (!level.isSelected) return [];

    const selectedChildren = (level.children || []).filter(
      child => child.isSelected
    );

    if (selectedChildren.length === 0) {
      return [level];
    }
    const deepestSelectedOptions: CategoryFilterOption[] = [];
    selectedChildren.forEach(child => {
      const selectedOptions = getDeepestSelectedOptions(child);
      deepestSelectedOptions.push(...selectedOptions);
    });

    return deepestSelectedOptions;
  };

  const deepestSelectedCategories: CategoryFilterOption[] = filter.data.flatMap(
    level => getDeepestSelectedOptions(level)
  );

  return deepestSelectedCategories;
};

export const normalizePathFromQuery = (raw: string) => {
  if (!raw) return "";

  const s = raw.startsWith("?") ? raw.slice(1) : raw;

  const decoded = decodeURIComponent(s);

  const withoutProto = decoded.replace(/^https?:\/\/[^/]+/i, "");
  const clean = withoutProto.replace(/^\/+/, "");

  if (!clean || clean.startsWith("?") || clean.startsWith("#")) return "";
  if (clean.includes("..")) return "";

  return clean;
};
